import { Link, useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { useShop } from "../store/ShopContext";

export const CompareBar = () => {
  const { compare, toggleCompare, clearCompare } = useShop();
  const { pathname } = useLocation();
  const visible = compare.length > 0 && pathname !== "/comparare" && !pathname.startsWith("/checkout");

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="compare-bar"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-4 inset-x-0 mx-auto w-fit z-30 glass border border-black/10 shadow-xl px-4 py-3 flex items-center gap-4 max-w-[calc(100vw-2rem)]"
        >
          <div className="flex items-center gap-2">
            {compare.map((p) => (
              <div key={p.slug} className="relative surface h-12 w-12 flex items-center justify-center p-1">
                <img src={p.image} alt={p.name} className="product-img max-h-full object-contain" />
                <button data-testid={`compare-bar-remove-${p.slug}`} aria-label="Elimină" onClick={() => toggleCompare(p)} className="absolute -top-1.5 -right-1.5 h-5 w-5 rounded-full bg-[#0A0A0A] text-white flex items-center justify-center"><X size={10} /></button>
              </div>
            ))}
            {Array.from({ length: 3 - compare.length }).map((_, i) => (
              <div key={i} className="hidden sm:block h-12 w-12 border border-dashed border-black/20" />
            ))}
          </div>
          <div className="hidden sm:block text-xs text-[#737373] w-28">{compare.length} / 3 produse</div>
          <Link to="/comparare" data-testid="compare-bar-link" className="btn-primary h-10 px-5 text-[11px]">Compară</Link>
          <button data-testid="compare-bar-clear" onClick={clearCompare} className="hidden sm:block text-xs uppercase tracking-[0.14em] text-[#737373] hover:text-[#0A0A0A]">Golește</button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
